const sangApp = {
	documentready: function (fn) {
		if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	},
	className: function (el) {
		return document.getElementsByClassName(el);
	},
	tagName: function (el) {
		return document.getElementsByTagName(el)
	},
	id: function (el) {
		return document.getElementById(el)
	},
	selector: function (el) {
		return document.querySelector(el)
	},
	fadeIn: function (el) {
		let elm = document.querySelector(el);
		elm.style.opacity = 0;

		var last = +new Date();
		var tick = function () {
			elm.style.opacity = +elm.style.opacity + (new Date() - last) / 400;
			last = +new Date();

			if (+elm.style.opacity < 1) {
				(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
			}
		};

		tick();
	},
	hide: function (el) {
		el.style.display = 'none';
	},
	addClass: (el, className) => {
		if (el.classList)
			el.classList.add(className);
		else
			el.className += ' ' + className;
	},
	removeClass: function (el, className) {
		if (el.classList)
			el.classList.remove(className);
		else
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	},
	after: function (el, htmlString) {
		el.insertAdjacentHTML('afterend', htmlString);
	},
	before: function (el, htmlString) {
		el.insertAdjacentHTML('beforebegin', htmlString);
	},
	append: function (parent, el) {
		parent.innerHTML += el;
	},
	each: function (el, fn) {
		Array.prototype.forEach.call(el, fn());
	},
	toggle: function (el, className) {
		if (el.classList) {
			el.classList.toggle(className);
		} else {
			var classes = el.className.split(' ');
			var existingIndex = classes.indexOf(className);

			if (existingIndex >= 0)
				classes.splice(existingIndex, 1);
			else
				classes.push(className);

			el.className = classes.join(' ');
		}
	}
}
